import { useNavigate } from 'react-router-dom';

import { Form } from '@components/form';
import { Modal, useModal } from '@components/modal';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';

import { useCreateMCPServer } from 'api/mcp/hooks';
export const useCreateMCPServerModal = () => {
  return useModal(CreateMCPServerModal);
};

const CreateMCPServerModal = () => {
  const { t } = useScopedTranslate(locale);
  const createMCPServerMutation = useCreateMCPServer();
  const navigate = useNavigate();

  return (
    <Modal>
      <Modal.SimpleHeader title={t('createMCPServer')} />
      <Modal.Content>
        <Stack space={4}>
          <Form
            onSubmit={async (values: any) => {
              await createMCPServerMutation
                .mutateAsync({
                  label: values.name,
                  description: '',
                })
                .then((response) => {
                  navigate(`/settings/mcp-servers/${response.clientId}`);
                });
            }}
          >
            <Form.TextField id="name" label={t('name')} placeholder={t('name')} required />
            <Stack orientation="horizontal" space={4} justify="flex-end">
              <Form.Submit text={t('create')} disabled={createMCPServerMutation.isLoading} />
            </Stack>
          </Form>
        </Stack>
      </Modal.Content>
    </Modal>
  );
};

const locale = {
  en: {
    createMCPServer: 'Create MCP Server',
    name: 'Name',
    create: 'Create',
  },
};
